module.exports = __webpack_public_path__ + "static/img/acq-1.baaaf5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acq-1.png
// module id = LrI/
// module chunks = 1